import React from "react"
import RecognitionForm from "../../components/RecognitionForm"

const Recognition: React.FC = () => {
    return <RecognitionForm />
}

export default Recognition
